import { useRouter } from 'next/router';

export const useURLHelpers = (url?: string) => {
  const { asPath, basePath } = useRouter();
  const currentPathWithoutBase = asPath.split('?')[0].replace(basePath, '');
  const urlWithoutBasePath = url?.replace(basePath, '');

  let isCurrentUrl =
    !!urlWithoutBasePath && currentPathWithoutBase === urlWithoutBasePath;

  // Listing Offer Management routes need to be handled differently
  if (
    urlWithoutBasePath?.includes('listings') &&
    urlWithoutBasePath.includes('offers')
  ) {
    isCurrentUrl = currentPathWithoutBase.startsWith(urlWithoutBasePath);
  }

  return {
    urlWithoutBasePath,
    isCurrentUrl,
    currentUrl: asPath,
    basePath,
  };
};
